import { generationJobErrorCopy, generationPhaseLabel, generationStageLabel, generationStatusLabels, generationTime } from './generationCopy';
import { VersionPanel } from './VersionPanel';
import { GenerationReadError } from './GenerationReadError';
import { useGenerationDetail } from './useGenerationQueries';

export function GenerationDetail({ id }: { id: string }) {
  const query = useGenerationDetail(id);
  const job = query.isError ? undefined : query.data;

  return (
    <section className="map-generations__panel" aria-label="Выбранный запуск">
      <h2>Выбранный запуск</h2>
      <button className="workspace-secondary-button" type="button" disabled={query.isFetching} onClick={() => { void query.refetch(); }}>
        Обновить запуск
      </button>
      {query.isPending && <p role="status">Загрузка запуска…</p>}
      {query.isError && (
        <GenerationReadError error={query.error} retry={() => { void query.refetch(); }} pending={query.isFetching} label="Повторить загрузку запуска" />
      )}
      {job && (
        <>
          <p className="map-generations__identifier">{job.id}</p>
          <p>{generationStatusLabels[job.status]}</p>
          <progress aria-label="Прогресс генерации" max="100" value={job.percent} />
          <p><strong>{Math.floor(job.percent)}%</strong> · {generationPhaseLabel(job.phase)}</p>
          <p>{generationStageLabel(job.stage, job.status)}</p>
          {job.error_code && <p role="alert">{generationJobErrorCopy(job.error_code)}</p>}
          {job.status === 'recovery_required' && !job.error_code && (
            <p role="alert">Публикация требует проверки оператором.</p>
          )}
          <dl className="map-generations__facts">
            <dt>Обработано / всего</dt>
            <dd>{job.completed ?? '—'} / {job.total ?? '—'}</dd>
            <dt>Источник</dt>
            <dd>{job.source === 'cli' ? 'Командная строка' : 'Панель управления'}</dd>
            <dt>Ревизия границ</dt>
            <dd>{job.source_revision ?? 'Ещё не определена'}</dd>
            <dt>Версия кандидата</dt>
            <dd>{job.candidate_version ?? 'Ещё не определена'}</dd>
            <dt>Создан</dt>
            <dd>{generationTime(job.created_at)}</dd>
            <dt>Обновлён</dt>
            <dd>{generationTime(job.updated_at)}</dd>
            <dt>Начат</dt>
            <dd>{generationTime(job.started_at)}</dd>
            <dt>Завершён</dt>
            <dd>{generationTime(job.finished_at)}</dd>
          </dl>
          {job.candidate_version && <VersionPanel key={job.candidate_version} version={job.candidate_version} />}
        </>
      )}
    </section>
  );
}
